import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
  <h2>Delay In Transit - Departed Late</h2>
  <h3>SOP</h3>
  <p>1) Is a ROC Member assigned to this case?</p>
  <p><strong>If YES:</strong></p>
  <ol type="A">
    <li>Check the cases in the Paragon to see the latest updates
      <ul><li>If no cases are available in Paragon check FMC notes</li></ul>
    </li>
    <li>Check for ETA on truck (should be in Paragon case or in the FMC notes). Reach out to the ROC associate who is handling the escalation/WIM if there is no ETA in either Paragon or FMC notes
      <ul><li>Update the information in the notes section of this page</li></ul>
    </li>
    <li>Inform the following teams via email about the latest status of the truck and approx ETA:
      <ul>
        <li>XLOC</li>
        <li>Sort Center (if applicable)</li>
        <li>Delivery stations</li>
      </ul>
    </li>
    <li>Form a Chime group if it's a critical SEV 1</li>
  </ol>
  <p><strong>If NO:</strong></p>
  <ol type="A">
    <li>Go to WIMS and confirm</li>
    <li>Reach out to the ROC team dedicated for AMXL support to escalate</li>
    <li>If AZNG truck reach out via Paragon</li>
    <li>In parallel Chime the ROC leads of the specified team for help first on case assignment and action</li>
    <li>No reply for 1 hour - reach out to the PM of the ROC team to further escalate</li>
    <li>Inform the following teams via email about the latest status of the truck might be delayed and approx ETA if available:
      <ul>
        <li>XLOC</li>
        <li>Sort Center (if applicable)</li>
        <li>Delivery stations</li>
        <li>CSC/XLOC last mile - only if this is SEV1</li>
        <li>Network Planning - only if this is SEV1</li>
      </ul>
    </li>
    <li>Form a Chime group if necessary</li>
  </ol>
  <p>When the Truck is within 1 mile radius of the destination and relay check in stamp is YES. Resolve this exception.</p>
</div>`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMXL_DELAY_IN_TRANSIT_DEPARTED_LATE.jsx